import { useIntl } from "react-intl";

const MDM = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.MDM.header",
            defaultMessage: "MDM (Mobile Device Management)"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.MDM.body",
            defaultMessage:
                "Enforce security controls on mobile app usage through built-in Mobile Device Management (MDM) support for iOS and Android."
        }),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.MDM.link",
                defaultMessage: "<learnMore>Learn more</learnMore> about MDM."
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href="https://support.atlassian.com/security-and-access-policies/docs/mobile-device-management-mdm-for-atlassian-mobile-apps/"
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.link}</p>
        </>
    );
};

export default MDM;
